import { createClient } from "next-sanity";

const config = {
  projectId: "muo5rc80", // e.g. "muo5rc80"
  dataset: "production",
  apiVersion: "2024-05-11",
  useCdn: false,
};

export const sanityClient = createClient(config);
export default config;
